import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { FailedMessagesProfileReportFacade } from './failed-messages-profile-report.facade';

@Injectable({ providedIn: 'root' })
export class FailedMessagesProfileReportGuard {
  constructor(private failedMessagesProfileReportFacade: FailedMessagesProfileReportFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { profileId },
    } = route;
    return checkStoreState(this.failedMessagesProfileReportFacade, profileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.failedMessagesProfileReportFacade);
  }
}
